import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-default-loading-icon',
  templateUrl: './default-loading-icon.component.html',
  styleUrls: ['./default-loading-icon.component.scss']
})
export class DefaultLoadingIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
